import { BIBLE_BOOKS } from './bibleBooks';

/**
 * The day a chapter was read. `readDate` is a YYYY-MM-DD calendar date, so it
 * is formatted as a local date (new Date('2026-09-29') is UTC midnight, the
 * day before in the Americas). Falls back to when the report was logged.
 */
export function formatReadDate(report) {
  const day = String(report?.readDate || '').slice(0, 10);
  const [year, month, date] = day.split('-').map(Number);
  if (year && month && date) {
    return new Date(year, month - 1, date).toLocaleDateString();
  }
  return report?.reportedAt ? new Date(report.reportedAt).toLocaleDateString() : '';
}

/** Book names for the filter: the whole canon, narrowed by testament. */
export function bookOptions(testament = '') {
  return BIBLE_BOOKS
    .filter((book) => !testament || book.testament === testament)
    .map((book) => book.name);
}
